import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Skeleton,
  useTheme,
} from "@mui/material";

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
const METRICS = ["TWR", "SHARPE", "SORTINO", "LARGEST DRAWDOWN"];
const SKELETON_ROWS = 3;

const AnnualPerformanceTableSkeleton = () => {
  const theme = useTheme();

  return (
    <Box>
      <TableContainer
        component={Paper}
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          backgroundColor: theme.palette.background.paper,
          overflowX: "hidden",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow
              sx={{
                "& th": {
                  padding: "12px 8px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableCell sx={{ textAlign: "left", minWidth: 80 }}>
                <Skeleton variant="text" width={40} animation="wave" />
              </TableCell>
              {MONTHS.map((month) => (
                <TableCell key={month}>
                  <Skeleton variant="text" width={28} animation="wave" sx={{ mx: "auto" }} />
                </TableCell>
              ))}
              {METRICS.map((metric) => (
                <TableCell key={metric}>
                  <Skeleton variant="text" width={metric === "LARGEST DRAWDOWN" ? 60 : 40} animation="wave" sx={{ mx: "auto" }} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: SKELETON_ROWS }).map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  "&:nth-of-type(odd)": {
                    backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)",
                  },
                  "& td": {
                    padding: "12px 8px",
                    textAlign: "center",
                  },
                }}
              >
                <TableCell sx={{ textAlign: "left" }}>
                  <Skeleton variant="text" width={36} animation="wave" />
                </TableCell>
                {Array.from({ length: MONTHS.length + METRICS.length }).map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton variant="text" width={36} animation="wave" sx={{ mx: "auto" }} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AnnualPerformanceTableSkeleton;
